import {
  AppBar,
  Box,
  Button,
  Grid,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import SendIcon from '@material-ui/icons/SendRounded';
import AttachFile from '@material-ui/icons/AttachFileRounded';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../Components/BreadCrumb';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../../Utils/routes.json';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import EditOutlined from '@material-ui/icons/EditOutlined';
import { useState } from 'react';
import KenCard from '../../../../global_components/KenCard';
import KenGrid from '../../../../global_components/KenGrid';
import KenPopover from '../../../../Components/KenPopOver';
import KenDialogBox from '../../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../../global_components/KenSelect';
import { RiFilterLine } from 'react-icons/ri';
import Kentable from '../../../../global_components/KenTable/kentable';
import { Message } from '@material-ui/icons';
import ChatLayout from '../../components/ChatLayout';
import ChatInput from '../../components/ChatInput';
import moment from 'moment';

const arrayBreadCrumb = [
  { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
  },
  {
    head: 'SEATING PLAN',
  },
];

const chatData = [
  {
    sender: true,
    message: `Hey, Could you please let me know which chapters I have to cover
  in UX/UI paper?`,
    profilePic: 'https://ptetutorials.com/images/user-profile.png',
    time: '3 days ago',
  },
  {
    sender: false,
    message: `Hi Nandhini, you should include first 8 chapters in mid semester
    exam.`,
    profilePic: '',
    time: '3 days ago',
  },
  {
    sender: true,
    message: `Okay, Thank you gentleman!`,
    profilePic: 'https://ptetutorials.com/images/user-profile.png',
    time: '3 days ago',
  },
];

const ActionCellSendMessage = (row) => {
  const classes = useStyles();

  // Message Modal
  const [messageDialog, setMessageDialog] = useState(false);

  function handleMessageDialog() {
    setMessageDialog((prevState) => !prevState);
  }
  const { id } = row.row.values;

  const handleClick = () => {
    handleMessageDialog();
  };

  const [chats, setChats] = useState(chatData);
  const [typedMessage, setTypedMessage] = useState(
    'Anytime, You are always welcome!'
  );

  const messageChangeHandler = (e) => {
    setTypedMessage(e.target.value);
  };

  const sendMessageHandler = () => {
    if (!typedMessage) {
      return;
    }

    setChats((prev) => {
      return [
        ...prev,
        {
          sender: false,
          message: typedMessage,
          profilePic: '',
          time: moment(new Date()).fromNow(),
        },
      ];
    });

    setTypedMessage('');
  };
  return (
    <>
      <Message
        style={{
          color: '#092682',
          cursor: 'pointer',
        }}
        className="m-0"
        onClick={handleClick}
      />
      {/* Message Modal */}
      <KenDialogBox
        title={
          <Typography
            variant="p"
            className={classes.modalHeader}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <p>
              <img
                style={{ borderRadius: '50%', marginRight: '10px' }}
                width="40"
                height="40"
                src={'http://dummyimage.com/174x172.png/5fa2dd/ffffff'}
                alt="user"
              />
              {'Faculty 1'}
            </p>
            <p>Subject 1, Subject 2, Subject 3</p>
            <p>Room 1</p>
            <Typography variant="p">Monday, 10th January, 2022</Typography>{' '}
          </Typography>
        }
        open={messageDialog}
        handleClose={() => handleMessageDialog()}
        hidePositiveButton={true}
        hideNegativeButton={true}
        maxWidth="md"
        dividers
      >
        <div className="chat-box-part">
          <ChatLayout chats={chats} />

          <ChatInput
            typedMessage={typedMessage}
            messageChangeHandler={messageChangeHandler}
            sendMessageHandler={sendMessageHandler}
          />
        </div>
      </KenDialogBox>
    </>
  );
};
const ActionCellEdit = (row, isUpdating) => {
  const { id } = row.row.values;

  const editHandler = () => {
    console.log(id, 'Editing started');
  };
  return <EditOutlined className="m-0" onClick={editHandler} />;
};

const CellWithButton = (row) => {
  const classes = useStyles();
  const { eligibility_status } = row.row.values;

  console.log({ eligibility_status });

  let classOfBtn;
  if (eligibility_status === 'Eligible') {
    classOfBtn = classes.normal;
  } else if (eligibility_status === 'Not eligible') {
    classOfBtn = classes.error;
  } else {
    classOfBtn = classes.medium;
  }

  return (
    <Box>
      <Button
        variant="primary"
        component={Link}
        className={classOfBtn}
        // to={`${routes.currentProgrammes}/${id}/details`}
      >
        {eligibility_status}
      </Button>
    </Box>
  );
};

const UserCell = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%', marginRight: '10px' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const data = [
  {
    id: 1,
    name: 'Jane Cooper',
    message: 'Message 1',
  },
  {
    id: 2,
    name: 'Wade Warren',
    message: 'Message 2',
  },
  {
    id: 3,
    name: 'Cameron Williamson',
    message: 'Message 3',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  modalHeader: {
    fontWeight: 'normal',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    '& p': {
      marginRight: '25px',
    },
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    height: '28px',
    width: '78px',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    color: '#FFFFFF',
    background: 'orange',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  normal: {
    color: '#FFFFFF',
    background: 'green',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  medium: {
    color: '#FFFFFF',
    background: '#55b0cd',
    width: '102px',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));

const selectOptionsCampus = [
  {
    label: 'Select Campus',
    value: '--Select--',
  },
  {
    label: 'Campus 1',
    value: '1',
  },
  {
    label: 'Campus 2',
    value: '2',
  },
];

const selectOptionsProgram = [
  {
    label: 'Select Program',
    value: '--Select--',
  },
  {
    label: 'Program 1',
    value: '1',
  },
  {
    label: 'Program 2',
    value: '2',
  },
];

const selectOptionsSubject = [
  {
    label: 'Select Subject',
    value: '--Select--',
  },
  {
    label: 'Subject 1',
    value: '1',
  },
  {
    label: 'Subject 2',
    value: '2',
  },
];

const selectOptionsTerm = [
  {
    label: 'Select Term',
    value: '--Select--',
  },
  {
    label: 'Term 1',
    value: '1',
  },
  {
    label: 'Term 2',
    value: '2',
  },
];

const selectOptionsBatch = [
  {
    label: 'Select Batch',
    value: '--Select--',
  },
  {
    label: 'Batch 1',
    value: '1',
  },
  {
    label: 'Batch 2',
    value: '2',
  },
];

const UserCellBulkMessage = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const sendBulkDataGrid = [
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Raleigh Avieson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Fleur Fowler'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Nealy Leitch'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Carolyne Angrock'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Abeu Aiers'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Penny Scrivinor'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Grier Laverick'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Dur Leile'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Claudine Owenson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Stefa True'
    ),
  },
];

const InvigilationNotification = () => {
  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const [selectValueCampus, setSelectValueCampus] = useState(
    selectOptionsCampus[0].value
  );
  const handleSelectChangeCampus = (e) => {
    setSelectValueCampus(e.target.value);
  };

  const [selectValueProgram, setSelectValueProgram] = useState(
    selectOptionsProgram[0].value
  );
  const handleSelectChangeProgram = (e) => {
    setSelectValueProgram(e.target.value);
  };

  const [selectValueSubject, setSelectValueSubject] = useState(
    selectOptionsSubject[0].value
  );
  const handleSelectChangeSubject = (e) => {
    setSelectValueSubject(e.target.value);
  };

  const [selectValueTerm, setSelectValueTerm] = useState(
    selectOptionsTerm[0].value
  );
  const handleSelectChangeTerm = (e) => {
    setSelectValueTerm(e.target.value);
  };

  const [selectValueBatch, setSelectValueBatch] = useState(
    selectOptionsBatch[0].value
  );
  const handleSelectChangeBatch = (e) => {
    setSelectValueBatch(e.target.value);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [filterDialog, setFilterDialog] = useState(false);

  function handleFilterDialog() {
    setFilterDialog((prevState) => !prevState);
  }

  const [sendBulkMessageDialog, setSendBulkMessageDialog] = useState(false);

  function handleSendBulkMessageDialog() {
    setSendBulkMessageDialog((prevState) => !prevState);
  }

  const [selectAllData, setSelectAllData] = useState(false);

  const handleSelectRow = (evt, row, index) => {
    // TODO code here to perform actions on selecting row in table
  };

  const handleSelectAllRows = (state) => {
    // TODO code here to perform actions on selecting all rows in table
    setSelectAllData(state);
  };

  const columns = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: 'FacultyName',
      accessor: 'name',
      disableGlobalFilter: true,
    },
    {
      Header: 'Message',
      accessor: 'message',
      disableGlobalFilter: true,
    },
    {
      Header: 'Send Message',
      accessor: 'send_message',
      Cell: ActionCellSendMessage,
    },
  ];

  // Editing
  const [dataOfTable, setDataOfTable] = useState(data);
  const [isEditing, setIsEditing] = useState(false);

  return (
    <Box>
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Notification
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
            >
              Save
            </Button>
          </Grid>
        </Toolbar>
      </AppBar>
      <AppBar
        position="static"
        elevation={0}
        className={classes.header}
        style={{ margin: '20px 0' }}
      >
        <Toolbar style={{ color: '#505F79', fontWeight: 'bold' }}>
          {/* <Typography variant="p" style={{ marginRight: '25px' }}>
            {currentSeatingPlanData.course}
          </Typography> */}

          <Typography variant="p">Monday, 10th January, 2022</Typography>
        </Toolbar>
      </AppBar>
      <Box className={`cardlsitbox`}>
        <KenCard elevation={0}>
          <KenGrid
            columns={columns}
            data={dataOfTable}
            pagination={{ disabled: true }}
            toolbarDisabled={true}
            initialState={{
              hiddenColumns: ['id'],
            }}
            gridProps={{
              getCellProps: (row) => {
                if (
                  row.column.Header === 'Send Message' ||
                  row.column.Header === 'Edit'
                ) {
                  return {
                    style: {
                      textAlign: 'center',
                    },
                  };
                }
                return {
                  style: {
                    textAlign: 'left',
                  },
                };
              },
              getHeaderProps: (column) => {
                if (
                  column.Header === 'Send Message' ||
                  column.Header === 'Edit'
                ) {
                  return {
                    style: {
                      textAlign: 'center',
                    },
                  };
                }
                return {
                  style: {
                    textAlign: 'left',
                  },
                };
              },
            }}
          />
        </KenCard>
      </Box>

      {/* Filter Modal */}
    </Box>
  );
};

export default InvigilationNotification;
